import { render, staticRenderFns } from "./palm3.vue?vue&type=template&id=5da1d89c&scoped=true&"
import script from "./palm3.vue?vue&type=script&lang=js&"
export * from "./palm3.vue?vue&type=script&lang=js&"
import style0 from "./palm3.vue?vue&type=style&index=0&id=5da1d89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1d89c",
  null
  
)

export default component.exports